<template>
    <div v-if="loaded" class="nevs-content">
        <div class="nevs-content-top-buttons">
            <NevsButton class="success" @click="saveClick()">
                <i class="fa-solid fa-floppy-disk"></i>
                {{ $LANG.Get('buttons.save') }}
            </NevsButton>&nbsp;
            <NevsButton class="error" @click="backClick">
                <i class="fa-solid fa-arrow-left"></i>
                {{ $LANG.Get('buttons.back') }}
            </NevsButton>&nbsp;
            <NevsButton v-if="mode === 'edit' && personMembership.invoice_id !== null" @click="openInvoice()">
                <i class="fa-solid fa-file-invoice"></i>
                {{ $LANG.Get('buttons.openInvoice') }}
            </NevsButton>
        </div>
        <NevsCard class="form">
            <NevsSelect v-model="personMembership.person_id" :ajax="'select/persons'"
                        :error="personMembershipValidation.person_id"
                        :label="'*' + $LANG.Get('fields.person') + ':'"></NevsSelect>
            <NevsSelect v-if="!(mode === 'edit' && personMembership.membership_id === null && personMembership.name !== '')"
                        v-model="personMembership.membership_id" :ajax="'select/memberships'"
                        :error="personMembershipValidation.membership_id"
                        :label="'*' + $LANG.Get('fields.membership') + ':'"></NevsSelect>
            <NevsTextField v-else :model-value="personMembership.name" :readonly="true"
                           :label="$LANG.Get('fields.membership') + ':'"></NevsTextField>
            <NevsDateField v-model="personMembership.start_date" :error="personMembershipValidation.start_date"
                           :label="'*' + $LANG.Get('fields.startDate') + ':'"></NevsDateField>
            <NevsCheckbox v-if="mode === 'add'" v-model="createInvoice"
                          :label="$LANG.Get('fields.createInvoice')"></NevsCheckbox>
            <NevsSelect v-if="mode === 'edit'" v-model="personMembership.invoice_id" :ajax="'select/invoices'"
                        :nullable="true" :error="personMembershipValidation.invoice_id"
                        :label="$LANG.Get('fields.invoice') + ':'"></NevsSelect>
        </NevsCard>
    </div>
</template>

<script>
import PersonMembership from '@/models/PersonMembership.js';
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsDateField from "@/components/nevs/NevsDateField.vue";

export default {
    name: "EntityPersonMembership",
    components: {NevsDateField, NevsCheckbox, NevsSelect, NevsTextField, NevsButton, NevsCard},
    data() {
        return {
            loaded: false,
            mode: this.$route.params.id === '0' ? 'add' : 'edit',
            personMembership: new PersonMembership({id: this.$route.params.id}),
            personMembershipValidation: new PersonMembership({}, true),
            createInvoice: false
        }
    },
    methods: {
        validateForm() {
            let valid = true;

            if (this.personMembership.person_id === null) {
                valid = false;
                this.personMembershipValidation.person_id = this.$LANG.Get('labels.mandatoryField');
            } else {
                this.personMembershipValidation.person_id = '';
            }

            if (this.personMembership.membership_id === null && !(this.mode === 'edit' && this.personMembership.name !== '')) {
                valid = false;
                this.personMembershipValidation.membership_id = this.$LANG.Get('labels.mandatoryField');
            } else {
                this.personMembershipValidation.membership_id = '';
            }

            if (this.personMembership.start_date === '' || this.personMembership.start_date === null) {
                valid = false;
                this.personMembershipValidation.start_date = this.$LANG.Get('labels.mandatoryField');
            } else {
                this.personMembershipValidation.start_date = '';
            }

            return valid;
        },
        openInvoice() {
            let route = this.$router.resolve({path: '/invoices/' + this.personMembership.invoice_id + '/edit'});
            window.open(route.href, '_blank');
        },
        backClick() {
            if (window.history.length === 1) {
                window.close();
            } else {
                this.$router.back();
            }
        },
        saveClick() {
            if (!this.validateForm()) return;

            let vm = this;
            let requestMethod = this.mode === 'add' ? 'post' : 'put';
            let requestService = this.mode === 'add' ? 'person-memberships' : 'person-memberships/' + this.personMembership.id;
            this.$API.APICall(requestMethod, requestService, this.personMembership, (data, success) => {
                if (success) {
                    vm.$CROSS_TAB_BUS.TriggerEvent('reload-persons-memberships', {});
                    vm.$LOCAL_BUS.TriggerEvent('notification', {text: vm.$LANG.Get('alerts.recordSaved')});
                    if (vm.createInvoice && vm.mode === 'add') {
                        let route = vm.$router.resolve({
                            path: '/invoices/0/add',
                            query: {person_membership_id: data.person_membership.id}
                        });
                        window.open(route.href, '_blank');
                    }
                    vm.backClick();
                } else {
                    if (data.invoice_id) {
                        vm.personMembershipValidation.invoice_id = vm.$LANG.Get('alerts.invoiceCancelledLink');
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                    }
                }
            });
        }
    },
    mounted() {
        this.$store.commit('setHelpOverlay', []);
        this.$store.commit('selectMenu', 'personsMemberships');

        if (this.mode === 'add') {
            this.$store.commit('setBreadcrumbs', [
                {
                    label: this.$LANG.Get('modules.personsMemberships'),
                    link: '/persons-memberships'
                },
                {
                    label: this.$LANG.Get('modules.newPersonMembership'),
                    link: null
                }
            ]);
            this.loaded = true;
        } else {
            let vm = this;
            this.$API.APICall('get', 'person-memberships/' + this.personMembership.id, {}, (data, success) => {
                if (success && data.person_membership !== null) {
                    vm.personMembership.Fill(data.person_membership);
                    vm.$store.commit('setBreadcrumbs', [
                        {
                            label: vm.$LANG.Get('modules.personsMemberships'),
                            link: '/persons-memberships'
                        },
                        {
                            label: vm.personMembership.name,
                            link: null
                        }
                    ]);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
                vm.$nextTick(() => {
                    vm.loaded = true;
                });
            });
        }
    }
}
</script>

<style scoped>
.form {
    max-width: 350px;
    margin-bottom: 10px;
    padding: 15px;
}
</style>
